module.exports = __webpack_public_path__ + "static/shopPhoto-b1a9a0ccf30ef98a80190d64e9cc01a1.jpg";